import { render } from "./ReachWithin.vue?vue&type=template&id=063fc135&scoped=true"
import script from "./ReachWithin.vue?vue&type=script&lang=js"
export * from "./ReachWithin.vue?vue&type=script&lang=js"

import "./ReachWithin.vue?vue&type=style&index=0&id=063fc135&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063fc135"]])

export default __exports__